module.exports = __webpack_public_path__ + "img/register - grayscale.5a31810f.svg";